export const hentaiList = [
    {
        rank: 1,
        name: "??? ko có gì dau",
        description: "đừng nghĩ xấu nhen",
        image: "https://i.pinimg.com/736x/9f/8a/3c/9f8a3c1a6e33653ba397edfaec60947a.jpg",
        url: "https://i.pinimg.com/736x/9f/8a/3c/9f8a3c1a6e33653ba397edfaec60947a.jpg",
    },
    {
        rank: 2,
        name: "??? um ko có gì để nói",
        description: "nhạt quá :<",
        image: "https://i.pinimg.com/736x/a3/9f/96/a39f969b5963d74b65dd9d814437bef6.jpg",
        url: "https://i.pinimg.com/736x/a3/9f/96/a39f969b5963d74b65dd9d814437bef6.jpg",
    },
    {
        rank: 3,
        name: "respect người ta đi mà",
        description: "._.",
        image: "https://i.pinimg.com/736x/e2/44/ac/e244acb573a1cf068e611059935deb8e.jpg",
        url: "https://i.pinimg.com/736x/e2/44/ac/e244acb573a1cf068e611059935deb8e.jpg",
    },
        {
        rank: 4,
        name: "hé loo",
        description: "hihii",
        image: "https://i.pinimg.com/1200x/24/cf/4b/24cf4b3440961147f9fa5ec655eb2048.jpg",
        url: "https://i.pinimg.com/1200x/24/cf/4b/24cf4b3440961147f9fa5ec655eb2048.jpg",
    },
];
